import type { FC } from 'react';
import { Button } from '@carbon/react';
import {
  SidePanelClose,
  SidePanelOpen,
  TaskView,
  SendAlt,
} from '@carbon/react/icons';
import { WorkspaceShellHeader } from 'components/workspace-shell-header';

interface PreDrillWorkspaceHeaderProps {
  name: string;
  subtitle?: string;
  settingsOpen: boolean;
  tasksOpen: boolean;
  taskProgressLabel: string;
  promoteEnabled: boolean;
  onBack: () => void;
  onToggleSettings: () => void;
  onToggleTasks: () => void;
  onPromote?: () => void;
}

// Workspace header: shared WorkspaceShellHeader with pre-drill actions —
// settings toggle, Tasks toggle (N/M progress), and primary Promote action.
export const PreDrillWorkspaceHeader: FC<PreDrillWorkspaceHeaderProps> = ({
  name,
  subtitle,
  settingsOpen,
  tasksOpen,
  taskProgressLabel,
  promoteEnabled,
  onBack,
  onToggleSettings,
  onToggleTasks,
  onPromote,
}) => (
  <WorkspaceShellHeader
    title={`Wellbore Geometry Workspace · ${name}`}
    subtitle={subtitle}
    backLabel="Back to well"
    onBack={onBack}
    actions={
      <>
        <Button
          kind="ghost"
          size="md"
          hasIconOnly
          renderIcon={settingsOpen ? SidePanelClose : SidePanelOpen}
          iconDescription={settingsOpen ? 'Hide settings' : 'Show settings'}
          tooltipPosition="bottom"
          onClick={onToggleSettings}
        />
        <Button
          kind={tasksOpen ? 'tertiary' : 'ghost'}
          size="md"
          renderIcon={TaskView}
          onClick={onToggleTasks}
        >
          Tasks {taskProgressLabel}
        </Button>
        <Button
          kind="primary"
          size="md"
          renderIcon={SendAlt}
          disabled={!promoteEnabled || !onPromote}
          title={
            promoteEnabled
              ? 'Promote wellbore geometry'
              : 'Workspace already promoted'
          }
          onClick={onPromote}
        >
          Promote
        </Button>
      </>
    }
  />
);
